import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Habilitar"}>
                                <Button
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "close" : "check"}
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Grado',
                    dataIndex: 'nombreGrado',
                    key: 'nombreGrado',
                    sorter: true
                },
                {
                    title: 'Cuenta Contable',
                    dataIndex: 'cuentaContable',
                    key: 'cuentaContable',
                    sorter: true
                },
                {
                    title: 'Clase',
                    dataIndex: 'clase',
                    key: 'clase',
                    sorter: true
                },
                {
                    title: 'Sub-Cuenta',
                    dataIndex: 'subCuenta',
                    key: 'subCuenta',
                    sorter: true
                },
                {
                    title: 'Divisionaria',
                    dataIndex: 'divisionaria',
                    key: 'divisionaria',
                    sorter: true
                },
                {
                    title: 'Sub-Divisionaria',
                    dataIndex: 'subDivisionaria',
                    key: 'subDivisionaria',
                    sorter: true
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Tipo de Cuenta',
                    dataIndex: 'tipoCuenta',
                    key: 'tipoCuenta',
                    sorter: true
                },

                {
                    title: 'Columna Balance',
                    dataIndex: 'nombreColumnaBalance',
                    key: 'nombreColumnaBalance',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'nombreMoneda',
                    key: 'nombreMoneda',
                    sorter: true
                },
                {
                    title: 'Tipo de Cambio',
                    dataIndex: 'nombreTipoCambio',
                    key: 'nombreTipoCambio',
                    sorter: true
                },
                {
                    title: 'Estado Análisis',
                    dataIndex: 'estadoAnalisis',
                    key: 'estadoAnalisis',
                    align: 'center',
                    sorter: true,
                    render: (value) => {
                        return (<span>{value ? 'SI' : 'NO'}</span>)
                    }
                },
                {
                    title: 'Estado Proyecto',
                    dataIndex: 'estadoProyecto',
                    key: 'estadoProyecto',
                    align: 'center',
                    sorter: true,
                    render: (value) => {
                        return (<span>{value ? 'SI' : 'NO'}</span>)
                    }
                },
                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}